"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendVerificationEmail = exports.editProfileApi = void 0;
const axios_1 = __importDefault(require("axios"));
const env_config_1 = __importDefault(require("../../env.config"));
const fetchClient_1 = require("../../utils/misc/fetchClient");
const helpers_1 = require("../../helpers");
const generateAbbucket_1 = require("../../helpers/generateAbbucket");
const editProfileApi = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const baseUrl = env_config_1.default.API_URL_CLIENT;
    const cookies = (0, helpers_1.parseCookies)();
    const generatedABBucketFromDeviceUUID = (0, generateAbbucket_1.generateABBucket)();
    const userAbBucket = (cookies === null || cookies === void 0 ? void 0 : cookies["userABBucket"]) || generatedABBucketFromDeviceUUID;
    const headers = yield (0, fetchClient_1.getApiHeaders)();
    return axios_1.default.put(`${baseUrl}/members?isWhatsappEnabled=true&expand=ticket&abBucket=${userAbBucket}`, data, { headers: headers });
});
exports.editProfileApi = editProfileApi;
const sendVerificationEmail = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const cookies = (0, helpers_1.parseCookies)();
    const generatedABBucketFromDeviceUUID = (0, generateAbbucket_1.generateABBucket)();
    const userAbBucket = (cookies === null || cookies === void 0 ? void 0 : cookies["userABBucket"]) || generatedABBucketFromDeviceUUID;
    const baseUrl = env_config_1.default.API_URL_CLIENT;
    const headers = yield (0, fetchClient_1.getApiHeaders)();
    return axios_1.default.post(`${baseUrl}/slr/email?abBucket=${userAbBucket}`, data, { headers: headers });
});
exports.sendVerificationEmail = sendVerificationEmail;
